import React from "react";
import './blogs.css';

// ........ images .........
import thumb1 from '../../assets/images/thumb-1.svg';
import thumb2 from '../../assets/images/thumb-2.svg';
import thumb3 from '../../assets/images/thumb-3.svg';
import thumb4 from '../../assets/images/thumb-4.svg';
import thumb5 from '../../assets/images/thumb-5.svg';
import thumb6 from '../../assets/images/thumb-6.svg';
import {NavLink} from "react-router-dom";


function Blogs() {
   return (
       <div className="blog-page animate-page page-content sec-bottom-padding content-box width-1200">
          <div className="margin-b-60">
             <div className="title-font margin-b-20">Blog</div>
             <div className="search-box search-blogs search-icon-left">
                <input className="white-back font-15 light-color" type="text"
                       placeholder="Search for article, new, events"/>
             </div>
          </div>

          <ul className="blogs col-3">
             {[
                {id: 4, img: thumb4},
                {id: 5, img: thumb5},
                {id: 6, img: thumb6},
                {id: 1, img: thumb1},
                {id: 2, img: thumb2},
                {id: 3, img: thumb3},
                {id: 4, img: thumb4},
                {id: 5, img: thumb5},
                {id: 6, img: thumb6},
                {id: 1, img: thumb1},
                {id: 2, img: thumb2},
                {id: 3, img: thumb3}
             ].map((blog) => {
                return (
                    <li key={blog.id}>
                       <NavLink to={'/blogs-details'}>
                          <div className="blog-img icon">
                             <img src={blog.img} alt=""/>
                          </div>
                          <div className="blog-content">
                             <div className="blog-title rubik-medium">6 inspiring promo video ideas for your business</div>
                             <div className="flex font-12 user-details">
                                <div className="author">Vartika B</div>
                                <div className="date margin-l-30">November 16, 2022</div>
                             </div>
                             <div className="blog-desc">
                                Want to start creating promo videos for your business but stuck for ideas? We’ve…
                             </div>
                          </div>
                       </NavLink>
                    </li>
                )
             })
             }

          </ul>
       </div>
   )
}

export default Blogs;
